import { TutorialDefinition } from './tutorialDefinitions';

/**
 * Battle system tutorials - Phase 2 Implementation
 */

export const BATTLE_BASICS_TUTORIAL: TutorialDefinition = {
  key: 'battle-basics',
  title: 'Battle System Basics',
  description: 'Learn tactical grid-based combat fundamentals',
  category: 'combat',
  priority: 'critical',
  estimatedMinutes: 3,
  icon: '⚔️',
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Battle!',
      content: 'This is a tactical turn-based battle system. You\'ll control your units on a grid, strategically moving and attacking enemies. Let\'s learn the basics!',
      position: 'center',
      type: 'info'
    },
    {
      id: 'turn-order',
      title: 'Turn Order',
      content: 'The Turn Order panel shows who acts next. Units act based on their Speed stat - higher Speed goes first. The highlighted unit is currently taking their turn.',
      targetSelector: '.turn-order-section',
      position: 'bottom',
      type: 'info',
      highlightPadding: 12
    },
    {
      id: 'selecting-units',
      title: 'Selecting Units',
      content: 'Click on any unit (yours or enemies) to view their stats, HP, AP, and equipment. Your selected unit\'s details appear in the right panel.',
      position: 'center',
      type: 'info'
    },
    {
      id: 'action-points',
      title: 'Action Points (AP)',
      content: 'AP is used for attacks and skills. Each unit starts their turn with full AP. Moving costs Movement points, not AP. Watch your AP carefully!',
      position: 'center',
      type: 'info'
    },
    {
      id: 'movement',
      title: 'Moving Your Units',
      content: 'Click the "Move Unit" button to enter movement mode. Green tiles show where you can move. Click a tile to move there. Movement costs Movement points shown on the button.',
      targetSelector: '.action-btn.move-btn',
      position: 'bottom',
      type: 'info',
      highlightPadding: 8
    },
    {
      id: 'attacking',
      title: 'Attacking Enemies',
      content: 'Click the "Attack" button to enter attack mode. Red-highlighted enemies are in range. Click an enemy to attack them. Attacks cost AP based on your equipped weapon.',
      targetSelector: '.action-btn.attack-btn',
      position: 'bottom',
      type: 'info',
      highlightPadding: 8
    },
    {
      id: 'skills',
      title: 'Using Skills',
      content: 'Skills are powerful abilities from your skill tree. They appear below the action buttons when available. Skills cost AP and have cooldowns. Choose wisely!',
      position: 'center',
      type: 'info'
    },
    {
      id: 'terrain',
      title: 'Terrain & Positioning',
      content: 'Terrain affects combat! High ground gives bonuses, cover reduces damage, and hazards deal damage each turn. Position your units strategically.',
      position: 'center',
      type: 'info'
    },
    {
      id: 'end-turn',
      title: 'Ending Your Turn',
      content: 'When you\'re done with your actions, click "End Turn" to pass control to the next unit. Plan ahead - you can\'t undo after ending your turn!',
      targetSelector: '.action-btn.end-turn-btn',
      position: 'bottom',
      type: 'info',
      highlightPadding: 8
    },
    {
      id: 'victory',
      title: 'Victory Conditions',
      content: 'Defeat all enemies to win! You\'ll earn experience, loot, and unlock new areas. If all your units fall, you\'ll lose the battle. Good luck, commander!',
      position: 'center',
      type: 'info'
    }
  ]
};

export const battleTutorials = [BATTLE_BASICS_TUTORIAL];
